import React from 'react';
import styled from 'styled-components';

import { TextBadge } from '../dashboardStyles';

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 1.25rem 1rem;
`;

const CircularProgressBarContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
`;

const CircularProgressBarText = styled.span`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 800;
  color: rgb(31, 41, 55);
`;

const CircularProgressBar = ({ percentage = 0, color }) => {
  const radius = 30;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference * (1 - percentage / 100);

  return (
    <CircularProgressBarContainer>
      <svg width="80" height="80" viewBox="0 0 80 80">
        {/* Background circle */}
        <circle
          cx="40"
          cy="40"
          r="30"
          fill="none"
          stroke="#F0F0F0"
          strokeWidth="9"
        />
        {/* Progress circle */}
        <circle
          cx="40"
          cy="40"
          r="30"
          fill="none"
          stroke={color}
          strokeWidth="9"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          transform="rotate(-90 40 40)"
        />
      </svg>
      <CircularProgressBarText>{percentage}%</CircularProgressBarText>
    </CircularProgressBarContainer>
  );
};

const LinearProgressBarContainer = styled.div`
  width: 100%;
  height: 6px;
  border-radius: 9999px;
  margin-top: 4px;
  background-color: rgb(243, 244, 246);
  overflow: hidden;
`;

const LinearProgressBarFill = styled.div`
  height: 100%;
  border-radius: 9999px;
  background-color: ${({ color }) => color};
  width: ${({ percentage }) => `${percentage}%`};
  transition: width 0.3s ease-in-out;
`;

const LinearProgressBar = ({ percentage = 0, color }) => {
  return (
    <LinearProgressBarContainer>
      <LinearProgressBarFill percentage={percentage} color={color} />
    </LinearProgressBarContainer>
  );
};

const TextFractionContainer = styled.div`
  display: flex;
  align-items: baseline;
  gap: 3px;
`;

const TextFractionNumerator = styled.span`
  font-size: 26px;
  font-weight: 800;
  color: rgb(31, 41, 55);
  line-height: 1;
`;

const TextFractionDenominator = styled.span`
  font-size: 12px;
  color: rgb(196, 196, 196);
  font-weight: 500;
`;

const TextFraction = ({ numerator = 0, denominator = 0 }) => {
  return (
    <TextFractionContainer>
      <TextFractionNumerator>{numerator}</TextFractionNumerator>
      <TextFractionDenominator>/ {denominator}</TextFractionDenominator>
    </TextFractionContainer>
  );
};

const CampContent = ({ badge, color, total, active }) => {
  return (
    <Card>
      <TextBadge color={color}>{badge}</TextBadge>
      <CircularProgressBar
        percentage={total ? Math.round((active / total) * 100) : 0}
        color={color}
      />
      <TextFraction numerator={active} denominator={total} color={color} />
      <LinearProgressBar
        percentage={total ? (active / total) * 100 : 0}
        color={color}
      />
    </Card>
  );
};

export default CampContent;
